(ns bec-core.cljs.events
  (:require [re-frame.core :as rf]
            [bec-cljs-common.re-frame.events]
            [ajax.core :refer [json-request-format json-response-format]]
            [day8.re-frame.http-fx]
            [bec-core.cljs.config :as config]
            [bec-core.cljs.db :refer [default-db]]
            [bec-cljs-common.utils.interop :as interop]))

(rf/reg-event-fx :initialize-db
  (fn [{:keys [current-db]} [_ _]]
    (let [local-storage-db (interop/local-storage)
          new-db (merge default-db current-db)
          initial-selected-view (:selected-view new-db)]
      {:db (assoc new-db :local-storage local-storage-db)
       :fx [(when-not (false? (:push-state? (second initial-selected-view)))
              [:routes-push-state [(first initial-selected-view) (second initial-selected-view)]])]})))

(rf/reg-event-fx :get-pokemon-info
  (fn [{:keys [db]} [_ connection-information]]
    {:db (assoc-in db [:loading :get-pokemon-info] true)
     :fx [[:http-xhrio {:method :get
                        :headers {:Cache-Control "no-cache"}
                        :uri "https://pokeapi.co/api/v2/pokemon/pikachu"
                        :format (json-request-format)
                        :response-format (json-response-format)
                        :timeout 15000
                        :on-success [:get-pokemon-info-success connection-information]
                        :on-failure [:get-pokemon-info-failure connection-information]}]]}))

(rf/reg-event-fx :get-pokemon-info-success
  (fn [{:keys [db]} [_ connection-information resp]]
    (reset! connection-information (assoc @connection-information :online true))
    {:db (assoc db :online true)
     :fx [[:dispatch [:request-success :get-pokemon-info resp]]]}))

(rf/reg-event-fx :get-pokemon-info-failure
  (fn [{:keys [db]} [_ connection-information resp]]
    (reset! connection-information (assoc @connection-information :online false))
    {:db (assoc db :online false)
     :fx [[:dispatch [:request-failure :get-pokemon-info resp]]]}))

(rf/reg-event-fx :select-view
  (fn [{:keys [db]} [_ view props]]
    (let [db (-> (assoc db :main-search nil)
               (assoc-in [:keypad "navbar-search-bar-input" :input] nil))
          push-state? (:push-state? props)
          props (dissoc props :push-state?)
          previous-props (dissoc (second (:selected-view db)) :push-state?)]
      {:db (cond
             (= view (first (:selected-view db)))
             (assoc db :selected-view [view props])
             (= view :previous-view)
             (assoc db
               :previous-view (:selected-view db)
               :selected-view (:previous-view db))
             :else
             (assoc db
               :previous-view (:selected-view db)
               :selected-view [view props]))
       :fx [(cond
              (= view (first (:selected-view db)))
              (when (and (not (false? push-state?))
                      (not (= previous-props props)))
                [:routes-push-state [view props]])
              (= view :previous-view)
              (when-not (false? push-state?)
                [:routes-push-state [(first (:previous-view db)) (second (:previous-view db))]])
              :else
              (when-not (false? push-state?)
                [:routes-push-state [view props]]))]})))

(rf/reg-event-fx :open-admin-viewport
  (fn [{:keys [db]} [_ machine-uuid]]
    {:db (assoc-in db [:loading :open-admin-viewport] true)
     :fx [[:http-xhrio {:method :get
                        :uri (str (config/get-bec-core-server-url) "/remote-viewport-token/" machine-uuid)
                        :format (json-request-format)
                        :response-format (json-response-format)
                        :timeout 15000
                        :on-success [:open-admin-viewport-success machine-uuid]
                        :on-failure [:open-admin-viewport-failure machine-uuid]}]]}))

(rf/reg-event-fx :open-admin-viewport-success
  (fn [{:keys [db]} [_ machine-uuid resp]]
    {:fx [[:open-url [(str "https://node.oche-admin.com/" machine-uuid
                        "/darts-admin-client/?bcore_viewport_chal=" (get resp "token"))]]
          [:dispatch [:request-success :open-admin-viewport resp]]]}))

(rf/reg-event-fx :open-admin-viewport-failure
  (fn [{:keys [db]} [_ machine-uuid resp]]
    {:fx [[:dispatch [:request-failure :open-admin-viewport resp]]]}))